import React from 'react';
import { default as moment } from "moment";
import { FlexJustify, FlexLeft } from "common/fragments/Flex";
import Loading from 'common/fragments/Loading';
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import IconView from 'common/views/icon/Icon.view';
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { iDef } from "core/util/TypeUtils";
import Config from './Config';
import UserSummary from './entities/UserSummary';
import UserOrganizations from './entities/UserOrganizations';
import labelProvider from "./UserSummary.labels";
import styled from "styled-components";
import ILocalCacheService from 'core/service/cache/ILocalCacheService';
import ServiceRegistry from 'core/util/ServiceRegistry';
import StringUtil from 'core/util/StringUtil';
import FetchResolverService from "core/service/resolver/impl/FetchResolver.service";
import TokenSession from 'core/util/session/TokenSession';

const resolverService = ServiceRegistry.get(FetchResolverService);

const query = () => `
	{
	  entities: userOrganizations(params: {}) {
		id
		name
		parent{
		  id
		}
		children{
		  id
		  name      
		  availableCredits {
			count
		 }
		}
		availableCredits {
			count
		}
	  }
	}
`;
/**
 * Styled Component for search box
 */
const DropdownIcon = styled.div`
	margin-left:20px;
`;

const CreditIcon = styled.div`
	margin-right: 15px;
`;

const TotalCreditDiv = styled.div`
	position: relative;	
	width:330px;
`;

const CreditDiv = styled.div`
	text-align: left; 
	text-transform: capitalize;
	width: calc(100% - 50px);
`;

const MenuSubDiv = styled.div`
	padding-top: 5px;
`;

const ListItem = styled.div`	
	position: absolute;
	background: rgb(255, 255, 255);
	z-index: 9;
	left: 0;
	border-radius: 5px 5px 5px 5px;
	margin-top: -4px;
	width: calc(100% - 10px);
	margin-left: 10px;
	padding-left: 15px;
	padding-right: 15px;
	padding-top: 10px;
	color: #676767;
	box-sizing: border-box;
	opacity: .96;
	box-shadow: 2px 2px 3px 4px rgba(16, 22, 26, 0.4);
    border: 1px solid;
    border-color: white;
	padding: 10px;
`;
const MenuItem = styled.li`	
	padding-bottom: 5px;
	cursor: pointer;
`;

const OrgCreditEntry = styled.h6`
	border-bottom: 2px solid #D4D4D4;
	padding-top: 5px;
	padding-bottom: 5px;
    font-size: 10px;
`;

const ListULItem = styled.ul`
	margin-left: 20px;
`;


const { Labels } = labelProvider;
const childOrg = [];

interface ITotalCreditState {
	open: boolean,
	orgName: string,
	orgCredit: number,
	orgId: string | number
}

const UserSummaryQuery = Query.queryOne<UserSummary, any>(UserSummary);

@Panel({ id: "usersummary", configClass: Config, labelProvider })
export class FlexUserSummary extends React.PureComponent<IPanelProps<Config>, ITotalCreditState> {
	private container: React.RefObject<HTMLDivElement>;
	public constructor(props) {
		super(props);
		this.container = React.createRef();
		this.state = {
			open: false,
			orgName: "",
			orgCredit: 0,
			orgId: ""
		};
	}

	componentDidMount() {
		const storageService = ServiceRegistry.get(ILocalCacheService);
		document.addEventListener("mousedown", this.handleClickOutside);
		return resolverService.execute(query).then((response) => {
			return response.json();
		}).then((data) => (
			data.data.entities
		)).then((data: any) => {
			let orgExists;
			if (data) {
				data.forEach(function (element) {
					orgExists = element.id === storageService.getNumber("orgId");
					element.children && element.children.map(item => {
						childOrg.push(item.id)
					});
				});			
				let getStoredCredit = data.filter(element => (element.id === storageService.getNumber("orgId")));

				if (storageService.getNumber("orgId") && getStoredCredit.length > 0 ) {					
					this.setState({
						orgName: storageService.getString("orgName"),
						orgCredit: getStoredCredit[0].availableCredits.count,
						orgId: storageService.getNumber("orgId")
					});
				}
				else {
					this.setState({
						orgName: data[0].name,
						orgCredit: data[0].availableCredits.count,
						orgId: data[0].id
					});
					storageService.putNumber("orgId", data[0].id)
				}

			}
		});
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	handleClickOutside = event => {
		if (
			this.container.current &&
			!this.container.current.contains(event.target)
		) {
			this.setState({
				open: false
			});
		}
	};

	/**
	 * Toggle dropdown menu
	 */
	handleOnClick = () => {
		this.setState({
			open: !this.state.open
		});
	};

	private getStorageidKey() {
		return StringUtil.format("orgId");
	}

	private getStorageCreditKey() {
		return StringUtil.format("orgCredits");
	}

	private getStorageNameKey() {
		return StringUtil.format("orgName");
	}

	/**
	 * Render ul li based on list item
	 * @param list 
	 */
	getList = (list) => {
		return list.map(item => {
			const subList = item.children && <ListULItem>{this.getChildList(item.children)}</ListULItem>;
			return (
				!childOrg.includes(item.id) && (<MenuItem
					key={item.id}
					onClick={event => {
						this.storeOrgInfo(event, item);
					}}
				>
					<h6>{item.name}</h6>
					<OrgCreditEntry><Labels.TotalCredits args={{ totalcredits: (item.availableCredits ? item.availableCredits.count : 0).toString() }} />{}</OrgCreditEntry>
					{subList && <MenuSubDiv>{subList}</MenuSubDiv>}
				</MenuItem>)
			);
		});
	}

	/**
	 * Render child list item
	 * @param list 
	 */
	getChildList = (list) => {
		return list.map(item => {
			return (
				<MenuItem
					key={item.id}
					onClick={event => {
						this.storeOrgInfo(event, item);
					}}
				>
					<h6>{item.name}</h6>
					<OrgCreditEntry><Labels.TotalCredits args={{ totalcredits: (item.availableCredits ? item.availableCredits.count : 0).toString() }} />{}</OrgCreditEntry>

				</MenuItem>
			);
		});
	}

	/**
	 * Store org id in local storage 
	 * @param event 
	 * @param item	 
	 */
	storeOrgInfo = (event, item) => {
		// Stop event propagatation before calling handler passed in props
		event.stopPropagation();
		const storageService = ServiceRegistry.get(ILocalCacheService);
		const idkey = this.getStorageidKey();
		const creditkey = this.getStorageCreditKey();
		const namekey = this.getStorageNameKey();

		// add org id key to local storage
		storageService.putNumber(idkey, item.id);
		storageService.putNumber(creditkey, item.availableCredits ? item.availableCredits.count : 0);
		storageService.putString(namekey, item.name);

		this.props.actions.pushPageParam("orgid", item.id);
		this.setState({
			open: false,
			orgName: item.name,
			orgCredit: item.availableCredits ? item.availableCredits.count : 0,
			orgId: item.id
		});
	}

	public render() {
		return (
			<BlockView variant={BlockVariant.JUMBOTRON} viewKey="block">

				<UserSummaryQuery params={{}}>
					{
						({ data, loading }) => {
							if (loading) {
								return <Loading />;
							}

							if (!data) {
								return null;
							}

							const { config } = this.props;

							const {
								avatarURL,
								certificatesCount,
								lastLaunched,
								user
							} = data;


							let dateResult=false;
							if(lastLaunched !=null ) {
								const momentEndDate = moment(lastLaunched.endDate,'ddd MMM DD HH:mm:ss zzz YYYY');
								const momentCurrentDate = moment(new Date(),'ddd MMM DD HH:mm:ss zzz YYYY');
								dateResult= momentEndDate.isAfter(momentCurrentDate,'day');
							}

							const aUrl = iDef(avatarURL) ? avatarURL : config.defaultAvatarUrl;

							const avatar = (config.showAvatar && aUrl) && (
								<ImageView variant={ImageVariant.AVATAR} viewKey="avatar" src={aUrl} />
							);

							const userDetail = config.showUserDetails && user && (
								<div>
									<HeadingView variant={HeadingVariant.H5} viewKey="subtitle">
										<Labels.Welcome args={{user: `${user.firstName} ${user.lastName}`, firstName:`${user.firstName}`, lastName: `${user.lastName}`}} />
									</HeadingView>
								</div>
							);

							const lastLogin = (config.showLastLogin && user && user.lastLoginDate) && (
								<BlockView viewKey="last-login">
									<Labels.LastLogin args={{ date: user.lastLoginDate ? new Date(user.lastLoginDate) : undefined }} />
								</BlockView>
							);

							const certificatesEarned = config.showCertificates && (
								<PageLinkView viewKey="certificates-link">
									<ButtonView variant={ButtonVariant.PRIMARY} viewKey="certificates-button">
										<IconView icon="bookmark" viewKey="certificates-button.icon">
											<Labels.Certificates args={{ count: (certificatesCount || 0).toString() }} />
										</IconView>
									</ButtonView>
								</PageLinkView>
							);

							const lastLaunchedLink = (config.showLastLaunched && lastLaunched && lastLaunched.launchURL  && dateResult) && (
								<ButtonView variant={ButtonVariant.PRIMARY} viewKey="last-launched-button" onClick={() => window.open(lastLaunched.launchURL.launchURL, '_blank')}>
									<Labels.LastLaunched />
								</ButtonView>
							);
							return (
								<FlexJustify>
									<FlexLeft>
										{avatar}
										{userDetail}
									</FlexLeft>
									<div>
										<FlexJustify>
											{lastLogin}
											{certificatesEarned}
											{lastLaunchedLink}
										</FlexJustify>
									</div>
								</FlexJustify>
							);
						}
					}
				</UserSummaryQuery>
			</BlockView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/userSummary/FlexUserSummary.panel.tsx